module.exports = __webpack_public_path__ + "static/media/47-iveco.f8be2889.jpg";